import { checkoutPopup } from '../components/popups/CheckoutPopup';
export async function popCheckout(createCheckoutSession, stripePromise) {
    return await checkoutPopup.pop({ createCheckoutSession, stripePromise });
}
